define("checkout/components/input-stepper", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component"], function (_exports, _component, _templateFactory, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--btnGroup" data-test-id="input-stepper">
    <Shared::Ui::Button
      data-test-id="input-stepper-down-button"
      @type="outline"
      class="tCH--text--highlight"
      @isDisabled={{this.isStepDownDisabled}}
      @onClick={{@onStepDown}}
    >
      {{svg-jar "minus" class="o--icon--sm qa--minus_circle"}}
    </Shared::Ui::Button>
    {{#if (and this.isStepDownDisabled @tooltipAtMin) }}
      <EmberTooltip
        data-test-id="input-stepper-down-tooltip"
        @delay={{330}}
        @side="top"
      >
        {{@tooltipAtMin}}
      </EmberTooltip>
    {{/if}}
    <Shared::Ui::Button
      data-test-id="input-stepper-value"
      class="u--text--black"
      @type="outline"
    >
      {{@currentValue}}
    </Shared::Ui::Button>
    <Shared::Ui::Button
      data-test-id="input-stepper-up-button"
      class="tCH--text--highlight"
      @type="outline"
      @onClick={{@onStepUp}}
    >
      {{svg-jar "add" class="o--icon--sm qa--minus_circle"}}
    </Shared::Ui::Button>
  
  </div>
  
  */
  {
    "id": "fx+IKQ32",
    "block": "[[[10,0],[14,0,\"o--btnGroup\"],[14,\"data-test-id\",\"input-stepper\"],[12],[1,\"\\n  \"],[8,[39,0],[[24,\"data-test-id\",\"input-stepper-down-button\"],[24,0,\"tCH--text--highlight\"]],[[\"@type\",\"@isDisabled\",\"@onClick\"],[\"outline\",[30,0,[\"isStepDownDisabled\"]],[30,1]]],[[\"default\"],[[[[1,\"\\n    \"],[1,[28,[35,1],[\"minus\"],[[\"class\"],[\"o--icon--sm qa--minus_circle\"]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"],[41,[28,[37,3],[[30,0,[\"isStepDownDisabled\"]],[30,2]],null],[[[1,\"    \"],[8,[39,4],[[24,\"data-test-id\",\"input-stepper-down-tooltip\"]],[[\"@delay\",\"@side\"],[330,\"top\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[30,2]],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"  \"],[8,[39,0],[[24,\"data-test-id\",\"input-stepper-value\"],[24,0,\"u--text--black\"]],[[\"@type\"],[\"outline\"]],[[\"default\"],[[[[1,\"\\n    \"],[1,[30,3]],[1,\"\\n  \"]],[]]]]],[1,\"\\n  \"],[8,[39,0],[[24,\"data-test-id\",\"input-stepper-up-button\"],[24,0,\"tCH--text--highlight\"]],[[\"@type\",\"@onClick\"],[\"outline\",[30,4]]],[[\"default\"],[[[[1,\"\\n    \"],[1,[28,[35,1],[\"add\"],[[\"class\"],[\"o--icon--sm qa--minus_circle\"]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\\n\"],[13],[1,\"\\n\"]],[\"@onStepDown\",\"@tooltipAtMin\",\"@currentValue\",\"@onStepUp\"],false,[\"shared/ui/button\",\"svg-jar\",\"if\",\"and\",\"ember-tooltip\"]]",
    "moduleName": "checkout/components/input-stepper.hbs",
    "isStrictMode": false
  });

  class InputStepper extends _component2.default {
    get isStepDownDisabled() {
      return this.args.currentValue <= (this.args.minValue || 0);
    }

  }

  _exports.default = InputStepper;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, InputStepper);
});